import React, { useEffect, useRef, useState } from "react";
import Header from '../components/header';
import Footer from '../components/footer';
import { preweddingVideos } from '../constants/videos.js';
// css
import '../css/preweddings.scss';

const getYouTubeEmbedUrl = (url) => {
	const videoId = url.split('youtu.be/')[1]?.split('?')[0] || url.split('v=')[1]?.split('&')[0];
	return videoId ? `https://www.youtube.com/embed/${videoId}?enablejsapi=1&rel=0` : url;
};

const getYouTubeVideoId = (url) => {
	return url.split('youtu.be/')[1]?.split('?')[0] || url.split('v=')[1]?.split('&')[0] || '';
};

export const pauseOtherPlayers = (activeVideoId, players = {}) => {
	Object.entries(players).forEach(([videoId, player]) => {
		if (videoId !== activeVideoId && player?.pauseVideo) {
			player.pauseVideo();
		}
	});
};

const PagePreweddings = (props) => {
	const [playerMap, setPlayerMap] = useState({});
	const iframeRefs = useRef({});
	const playersRef = useRef({});

	useEffect(() => {
		const initializePlayers = () => {
			if (!window.YT?.Player) {
				return;
			}

			preweddingVideos.forEach((video) => {
				const iframe = iframeRefs.current[video.id];
				if (!iframe || playersRef.current[video.id]) {
					return;
				}

				const player = new window.YT.Player(iframe, {
					videoId: getYouTubeVideoId(video.url),
					playerVars: {
						rel: 0,
						playsinline: 1
					},
					events: {
						onStateChange: (event) => {
							if (event.data === window.YT.PlayerState.PLAYING) {
								pauseOtherPlayers(String(video.id), playersRef.current);
							}
						}
					}
				});

				playersRef.current[video.id] = player;
				setPlayerMap((prev) => ({ ...prev, [video.id]: player }));
			});
		};

		const tag = document.createElement('script');
		tag.src = 'https://www.youtube.com/iframe_api';
		tag.async = true;
		document.body.appendChild(tag);

		if (window.YT?.Player) {
			initializePlayers();
		} else {
			window.onYouTubeIframeAPIReady = initializePlayers;
		}

		return () => {
			document.querySelectorAll('script[src="https://www.youtube.com/iframe_api"]').forEach((script) => script.remove());
			delete window.onYouTubeIframeAPIReady;
		};
	}, []);

	return (
		<>
			<Header />
			
			<div className="page-preweddings">
				<div className="container">
					<h1 className="main-heading">Pre Wedding</h1>
					<div className="video-grid">
						{preweddingVideos.map((video) => (
							<article key={video.id} className="video-card" data-testid="video-card">
								<div className="video-frame">
									<iframe
										ref={(element) => {
											iframeRefs.current[video.id] = element;
										}}
										src={getYouTubeEmbedUrl(video.url)}
										title={video.title}
										loading="lazy"
										allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
										allowFullScreen
									></iframe>
								</div>
								{/* <h3>{video.title}</h3> */}
							</article>
						))}
					</div>
				</div>
			</div>

			<Footer />
		</>
	);
}

export default PagePreweddings